// extracted by mini-css-extract-plugin
export default {"tab-container":"ProjectListDetailTab_tab-container__oIE1Q","tab-panel":"ProjectListDetailTab_tab-panel__oCPbu","orderline-counter":"ProjectListDetailTab_orderline-counter__NFj-D"};